export const buildSupabaseRequestHeaders = (publishableKey, accessToken, additionalHeaders = {}) => ({
  'Content-Type': 'application/json',
  ...additionalHeaders,
  apikey: publishableKey,
  ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
})
